import { EnumUserRoute } from '@components-member/userRoutes/enums';

class BonusService {
  getBonusProposalDepositLink = () => {
    return EnumUserRoute.pspDeposit;
  };
}
export const bonusService = new BonusService();
